export default {"src":"/_next/static/media/codeai-logo-primary.b49fe7b7.svg","height":100,"width":591,"blurWidth":0,"blurHeight":0};